/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const TableBox = styled.div``;

export const LoaderBox = styled.div`
  margin-top: 50px;
`;

export const Container = styled.div`
  margin-bottom: 100px;
`;

export const SearchBox = styled.div`
  position: sticky;
  z-index: 1000;
  top: 76px;
`;

export const MyTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-top: none;
`;

export const TableHead = styled.thead`
  position: sticky;
  top: 125px;
  z-index: 900;
`;

export const TableFooter = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  padding: 12px;
  color: ${Palette.PrimaryGray._500};
  background-color: ${Palette.PrimaryGray._000};
  border: 1px solid ${Palette.PrimaryGray._200};
  border-top: unset;
`;

export const FooterBody = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  padding: 10px;
  border-left: 1px solid ${Palette.PrimaryGray._200};

  span {
    color: ${Palette.PrimaryGray._700};
  }
`;

export const ProgressBar = styled.div`
  position: relative;
  width: 64px;
  height: 4px;
  border-radius: 4px;
  background-color: ${Palette.PrimaryGray._200};
  overflow: hidden;

  ::before {
    content: ' ';
    position: absolute;
    height: 100%;
    width: ${({ status }) => `${status}%`};
    background-color: ${Palette.Primary._300};
  }
`;
